import whalersClub from './domains/whalersClub/testing.const';
import missions from './domains/missions/testing.const';

export default {
  whalersClub,
  missions,
};
